import { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { apiUrl } from "../../../../providers/companyInfo";

export default function ModalReport(props) {
	const { toggleModalReport, setToggleModalReport, tableFilter } = props;

	const [pdfUrl, setPdfUrl] = useState(null);

	useEffect(() => {
		if (toggleModalReport.open && toggleModalReport.data) {
			const url = apiUrl(
				`api/report_entrance_exam_pdf?${new URLSearchParams(tableFilter)}`
			);

			setPdfUrl(url);
		}
	}, [toggleModalReport]);

	return (
		<Modal
			wrapClassName="modal-wrap-report-preview"
			title="Report Preview"
			width={900}
			open={toggleModalReport.open}
			onCancel={() => {
				setToggleModalReport({
					open: false,
					data: null,
				});
				setPdfUrl(null);
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					key={1}
					onClick={() => {
						setToggleModalReport({
							open: false,
							data: null,
						});
						setPdfUrl(null);
					}}
				>
					CLOSE
				</Button>,
			]}
		>
			{pdfUrl ? (
				<iframe src={pdfUrl} frameBorder="0" width="100%" height="600px" />
			) : (
				<div style={{ textAlign: "center", padding: "20px" }}>No Data</div>
			)}
		</Modal>
	);
}
